// @tennis-matches/clubmeisterschaft-core/results – validate parts (pure)

/**
 * v1 minimal validation:
 * - in einem Satz müssen beide Seiten gefüllt sein (keine halbgefüllten Sets)
 * - keine negativen Werte
 * - wenn 2 Sätze gefüllt sind: nicht beide unentschieden (a==b) (optional)
 * @returns {{ ok: boolean, errKey?: string }}
 */
export function validateParts(parts) {
  const p = parts && typeof parts === "object" ? parts : {};

  const sets = [
    ["s1a", "s1b"],
    ["s2a", "s2b"],
    ["s3a", "s3b"],
  ];

  let any = false;
  for (const [ka, kb] of sets) {
    const a = p[ka];
    const b = p[kb];
    const aEmpty = a === "" || a === undefined || a === null;
    const bEmpty = b === "" || b === undefined || b === null;

    if (aEmpty && bEmpty) continue;
    any = true;

    if (aEmpty || bEmpty) return { ok: false, errKey: "club.entry.error.incompleteSet" };

    const na = Number(a);
    const nb = Number(b);
    if (!Number.isFinite(na) || !Number.isFinite(nb)) return { ok: false, errKey: "club.entry.error.invalidNumber" };
    if (na < 0 || nb < 0) return { ok: false, errKey: "club.entry.error.negative" };
  }

  if (!any) return { ok: true };

  return { ok: true };
}
